import { TextSelection } from 'prosemirror-state'
import { nanoid } from 'nanoid'

export function validateCustomListIds(tr, listableNodeTypes = []) {
  const { anchor, head } = tr.selection
  const commands = generateCustomListCorrectionMarkup(tr.doc, listableNodeTypes)
  let changed = false
  const sortedPos = Array.from(commands.keys()).sort((a, b) => a - b)
  for (const pos of sortedPos) {
    const attrs = commands.get(pos)
    if (attrs) {
      tr.setNodeMarkup(pos, undefined, attrs)
      changed = true
    }
  }
  if (changed) {
    tr.setSelection(TextSelection.create(tr.doc, anchor, head))
  }
  return changed ? tr : null
}

function generateCustomListCorrectionMarkup(
  doc,
  listableNodeTypes = [],
  commands = new Map(),
) {
  const contiguousLists = []
  let currentList = null

  doc.descendants((child, pos) => {
    const attrs = {
      ...child.attrs,
      ...(commands.get(pos) || {}),
    }
    if (child.type.name === 'customListItem') {
      if (!currentList) {
        currentList = []
        contiguousLists.push(currentList)
      }
      currentList.push({
        pos,
        child,
      })
    } else {
      if (!listableNodeTypes.includes(child.type.name)) {
        currentList = null
      }
    }
    return false
  })

  for (const list of contiguousLists) {
    const id = list.find((item) => !!item.child.attrs['list-id'])?.child.attrs[
      'list-id'
    ]
    let currentListId = id || nanoid()
    for (let i = 0; i < list.length; i++) {
      const { pos, child } = list[i]
      const existingId = child.attrs['list-id']
      if (existingId) {
        // If the list item already has a list-id, we don't need to give it one
        currentListId = existingId
        continue
      }
      const attrs = {
        ...child.attrs,
        ...(commands.get(pos) || {}),
        'list-id': currentListId,
      }
      commands.set(pos, attrs)
    }
  }

  return new Map()
}
